import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Loader } from 'shared/components';

import theme from './AppointmentsFetchPendingPlaceholder.scss';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const AppointmentsFetchPendingPlaceholder = ({ className }) => (
  <div className={ classnames(theme.root, className) }>
    <Loader />
  </div>
);

AppointmentsFetchPendingPlaceholder.propTypes = propTypes;
AppointmentsFetchPendingPlaceholder.defaultProps = defaultProps;

export default AppointmentsFetchPendingPlaceholder;
